import React, { useState, useEffect } from 'react';
import api from './api';

const TrackingTable = () => {
  const [clicks, setClicks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchClicks = async () => {
      try {
        const response = await api.get(`/clicks?page=${page}&limit=10`);
        setClicks(response.data.data.clicks || []);
        setTotalPages(response.data.data.totalPages || 1);
        setTotalItems(response.data.data.total || 0);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching clicks:', error);
        setLoading(false);
      }
    };

    fetchClicks();
  }, [page]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="card-premium">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="h5 mb-1 text-dark">Activity Log</h3>
          <p className="small text-muted mb-0">Real-time log of individual tracking events recorded</p>
        </div>
        <span className="badge bg-primary">
          {totalItems} total events
        </span>
      </div>

      <div className="table-responsive border rounded-3">
        <table className="table table-striped table-hover mb-0">
          <thead className="table-dark">
            <tr>
              <th className="px-3 py-3">Page Title</th>
              <th className="px-3 py-3">URL</th>
              <th className="px-3 py-3">Button Identifier</th>
              <th className="px-3 py-3">Session Key</th>
              <th className="px-3 py-3 text-end">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {clicks.length > 0 ? (
              clicks.map((click) => (
                <tr key={click.id} className="event-row">
                  <td className="px-3 py-3 text-truncate" style={{ maxWidth: '180px' }} title={click.pageTitle}>
                    {click.pageTitle || 'N/A'}
                  </td>
                  <td className="px-3 py-3">
                    <span className="text-primary text-truncate d-block" style={{ maxWidth: '200px', fontFamily: 'monospace' }} title={click.url}>
                      {click.url}
                    </span>
                  </td>
                  <td className="px-3 py-3">
                    <span className="badge-slate">
                      {click.buttonName}
                    </span>
                  </td>
                  <td className="px-3 py-3">
                    <span className="small text-muted font-monospace" title={click.sessionId}>
                      {click.sessionId ? click.sessionId.substring(0, 15) + '...' : 'anonymous'}
                    </span>
                  </td>
                  <td className="px-3 py-3 text-end text-muted small font-monospace">
                    {new Date(click.timestamp).toLocaleString()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4 text-muted">
                  No activities tracked yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-4">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className="btn btn-outline-secondary btn-sm"
          >
            Previous
          </button>
          <span className="small text-muted">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="btn btn-outline-secondary btn-sm"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default TrackingTable;
